export const LIST_STAFF_COLUMN = {
    NAME: 'name_staff',
    USERNAME: 'username',
    EMAIL: 'email',
    PHONE: "phone_staff",
    CREATE_AT: 'create_at',
    CREATOR: 'creator',
    ACTION: 'action',
};